import { render, staticRenderFns } from "./ProfileUsers.html?vue&type=template&id=12a27968&scoped=true&"
import script from "./ProfileUsers.vue?vue&type=script&lang=js&"
export * from "./ProfileUsers.vue?vue&type=script&lang=js&"
import style0 from "./ProfileUsers.scss?vue&type=style&index=0&id=12a27968&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a27968",
  null
  
)

export default component.exports